<div class="selectable-items-container">
  <div
    *ngFor="let item of selectorItems"
    class="selectable-item"
    (click)="setSelectedItem(item)"
    [class.active]="item.tab === selectedItem?.tab"
  >
    {{ item.tab }}
  </div>
</div>

<ng-container *ngIf="!!selectedItem.lineItems">
  <p class="selected-title">{{ selectedItem.title }}</p>
  <hr class="details-divider" />
  <div *ngFor="let item of selectedItem.lineItems">
    <div class="line-item-container">
      <p>{{ item.quantity }} x {{ item.name }}</p>
      <p class="value">{{ item.value | value }}</p>
    </div>
    <hr class="details-divider" />
  </div>
  <p class="total-amount line-items">{{ selectedItem.totalValue }}</p>
</ng-container>

<ng-container *ngIf="!selectedItem.lineItems">
  <p class="selected-title">{{ selectedItem.title }}</p>
  <div
    class="descriptions"
    *ngFor="let description of selectedItem.descriptions"
  >
    <p class="selected-title" *ngIf="description.title">
      {{ description.title }}
    </p>
    <p class="selected-text" *ngIf="description.text">{{ description.text }}</p>
    <zaver-button-link *ngIf="isDiscountedInterestRate"
      text="Avtal och villkor (pdf)"
      (click)="onOpenTerms()"
    ></zaver-button-link>
    <ng-container *ngIf="!!description.subItems">
      <ng-container *ngFor="let subItem of description.subItems">
        <hr class="details-divider" />
        <div class="line-item-container">
          <p>{{ subItem.title }}</p>
          <p class="value">{{ subItem.amount | value }}</p>
        </div>
      </ng-container>
      <hr class="details-divider" />
    </ng-container>
  </div>
  <ng-container *ngIf="selectedItem.totalValue">
    <hr class="details-divider" />
    <p class="total-amount">
      {{ selectedItem.totalValue }}
    </p>
  </ng-container>

  <div
    *ngFor="let attachment of selectedItem.attachments"
    style="margin-top: 20px; max-width: fit-content"
  >
    <zaver-button-link
      [text]="attachment.displayName"
      [iconUrl]="'/assets/icon/Icon-New-tab.svg'"
      (click)="validateThenOpenAttachmentInNewWindow(attachment)"
    ></zaver-button-link>
  </div>

  <div *ngFor="let link of selectedItem.links" style="margin-top: 16px">
    <zaver-button-link
      [text]="link.text"
      [iconUrl]="link.iconUrl"
      (click)="link.onClick()"
    ></zaver-button-link>
  </div>
</ng-container>
